import * as redux from "redux";
import { PACKAGE_NAME } from "../constants";
import { IStoreAction } from "./actions";
import { reducer } from "./reducer";
import { IStoreState } from "./reducer";

export * from "./actions";
export { IStoreState } from "./reducer";

export const createEnhancer = () =>
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__({
    name: `${PACKAGE_NAME} (${document.title})`
  });

export const createStore = () =>
  redux.createStore<IStoreState, IStoreAction, {}, {}>(
    reducer,
    createEnhancer()
  );
